import React from 'react';
import { CustomerPaymentProfileCardContract } from '../../../types/Customer';
import { CartPaymentProfileCardContract } from '../../../types/PaymentProfile';
import CardLogo from '../../content/CardLogo';

export const SavedCardSummaryTestId = 'SavedCardSummary-summary';
export type SavedCardSummaryProps = {
  card:
    | CustomerPaymentProfileCardContract
    | CartPaymentProfileCardContract
    | null;
};

const SavedCardSummary: React.FC<SavedCardSummaryProps> = ({
  card,
}: SavedCardSummaryProps) => {
  return (
    <div className="flex flex-row text-sm" data-testid={SavedCardSummaryTestId}>
      <CardLogo
        className="pr-2 mx-0 my-auto"
        cardTypeName={card?.cardTypeName ?? undefined}
      />
      <div className="flex flex-col">
        <p>
          <span>{card?.last4 !== '****' && '****'}</span>
          <span>{card?.last4}</span>
        </p>
        <p>{card?.holdersName}</p>
        {card?.expMonth && card?.expYear && (
          <p>
            Expires {card?.expMonth}/{card?.expYear}
          </p>
        )}
      </div>
    </div>
  );
};

export default SavedCardSummary;
